import { render, staticRenderFns } from "./UIPulseComponent.vue?vue&type=template&id=a963b7dc&scoped=true"
import script from "./UIPulseComponent.vue?vue&type=script&lang=ts"
export * from "./UIPulseComponent.vue?vue&type=script&lang=ts"
import style0 from "./UIPulseComponent.vue?vue&type=style&index=0&id=a963b7dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a963b7dc",
  null
  
)

export default component.exports